<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-document-checked"></i> {{baby.name ? (baby.name + '喂养的日常') : '记录列表' }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <el-table :data="tableData" border stripe class="table" header-cell-class-name="table-header">
        <!--<el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>-->
        <el-table-column prop="name" label="时间">
          <template slot-scope="scope">
            {{scope.row.time | format('YYYY-MM-DD hh:mm:ss')}}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            {{scope.row.recordType | formatRecordType()}}
          </template>
        </el-table-column>
        <el-table-column label="记录">
          <template slot-scope="scope">
            {{scope.row | formatRecord()}}
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="Record.pageIndex"
          :page-size="Record.limit"
          :total="Record.total"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  export default {
    computed: {
      ...mapState(["Baby", "Record"])
    },
    data() {
      return {
        tableData: [],
        baby: {}
      };
    },
    watch: {
      "$route" (to, from) {
        // console.log(to, from)
        if (to.name === "BabyRecord") {
          if (to.params.id !== this.id) {
            this.id = to.params.id
            this.init()
          }
        }
      },
      "Baby.currentBaby"(val) {
        this.baby = val;
      },
      "Record.list"(val) {
        this.tableData = val;
      }
    },
    created() {
      this.id = this.$route.params.id
      this.baby = this.Baby.currentBaby
      this.init()
    },
    methods: {
      ...mapActions([
        "setRecordOffset",
      ]),
      init () {
        if (!this.baby || this.baby.id !== this.id) {
          const baby = sessionStorage.getItem('baby_' + this.id)
          this.baby = baby && JSON.parse(baby)
        }
        if (!this.baby) return false
        this.setRecordOffset()
        this.getData()
      },
      // 获取 easy-mock 的模拟数据
      getData() {
        const Record = this.Record;
        const baby = this.baby;
        // console.log(baby)
        this.$api.getRecordList(baby.id, {
          offset: Record.offset || 0,
          limit: Record.limit,
          cooperate_id: baby.cooperate_id
        });
      },
      // 分页导航
      handlePageChange(index) {
        this.setRecordOffset({
          offset: (index - 1) * 10
        })
        this.getData()
      }
    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 300px;
    display: inline-block;
  }
  .table {
    width: 100%;
    font-size: 14px;
  }
  .red {
    color: #ff0000;
  }
  .mr10 {
    margin-right: 10px;
  }
  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/BabyRecord.vue